import { render } from "./bienvenida.vue?vue&type=template&id=3c9e436f"
import script from "./bienvenida.vue?vue&type=script&lang=js"
export * from "./bienvenida.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__